module.exports = __webpack_public_path__ + "static/scenario-truck-select.en-c68acad8e33a7b4ec8a3e1d12c733ed4.png";